import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_GROUPS(state, groups) {
    state.cached = groups
  },
}

export const actions = {

  init({ state, dispatch }) { },

  fetchGroups(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/groups/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_GROUPS', request)
      return request
    })
  },

  fetchGroupsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateGroups(context, formData) {
    let promise = null
    if (formData._id) {
      promise = axios.put(`${serverUrl}/base/groups/${formData._id}`, formData)
    } else {
      promise = axios.post(`${serverUrl}/base/groups/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteGroups(context, id) {
    let promise = null
    promise = axios.delete(`${serverUrl}/base/groups/${id}`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}